type SeenKind = 'auto' | 'beacon' | 'tour';

const keyOf = (kind: SeenKind, id: string) => `ai-pointer:${kind}:${id}`;

export function hasSeen(kind: SeenKind, id: string) {
  try {
    return localStorage.getItem(keyOf(kind, id)) === '1';
  } catch {
    return false;
  }
}

export function markSeen(kind: SeenKind, id: string) {
  try {
    localStorage.setItem(keyOf(kind, id), '1');
  } catch {}
}
